import styled from 'styled-components';

export const Container = styled.div`
	label {
		display: block;
		text-transform: uppercase;
		font-size: 0.9rem;
		margin-bottom: 0.5rem;
	}
`;

export const PropsList = styled.div`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
	align-items: center;

	select {
		width: 150px;
	}
`;

export const AddPropButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	font-size: 16px;
	line-height: 1;
	background: white;
	border: none;
	cursor: pointer;
`;
